import { useFormik } from 'formik';

import { EmailValidationFormProps, EmailValidationFormValues } from './interfaces';
import emailValidationFormValidationScheme from './validationScheme';

function useEmailValidationForm({ initialValues, onSubmit }: EmailValidationFormProps) {
	const formik = useFormik<EmailValidationFormValues>({
		initialValues,
		validationSchema: emailValidationFormValidationScheme,
		onSubmit,
	});

	return { formik };
}

export default useEmailValidationForm;
